AOS.init();
var pageWidth, pageHeight;

var basePage = {
  width: 800,
  height: 600,
  scale: 1,
  scaleX: 1,
  scaleY: 1
};

(function(){
    var page = document.querySelector('.bubble__animated');

    if(page != null) {
      if(window.innerWidth < 1024) {
        getPageSize();
        scalePages(page, pageWidth, pageHeight);
      } else if(window.innerWidth < 1280) {
        getPageSize();
        scalePages(page, pageWidth / 2, pageHeight / 2);
      }

      window.addEventListener('resize', function() {
        if(window.innerWidth < 1024) {
            getPageSize();            
            scalePages(page, pageWidth, pageHeight);
        } else if(window.innerWidth < 1280) {
          getPageSize();
          scalePages(page, pageWidth / 2, pageHeight / 2);
        } else {
            page.style.transform = '';
        }
      });
    }

    // Resize iframe
    var iframe = document.querySelector('iframe');
    if(iframe != null) {
      iframe.onload = function() {
        resizeIframe(this);
      };
    }

    function resizeIframe(obj) {
      obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
    }

    function getPageSize() {
      pageHeight = window.innerHeight;
      pageWidth = window.innerWidth;
    }

    function scalePages(page, maxWidth, maxHeight) {            
      var scaleX = 1, scaleY = 1;                      
      scaleX = maxWidth / basePage.width;
      scaleY = maxHeight / basePage.height;
      basePage.scaleX = scaleX;
      basePage.scaleY = scaleY;
      basePage.scale = scaleX;

      page.style.transform = 'scale(' + basePage.scale + ')';
    }
})();

$(document).ready(function(){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});